import * as actionTypes from '../actions/actionTypes';
import { updateObject } from '../utility';
import * as Metadata from 'Flow2/containers/Masterdata/Masterdata';

const initialState = {
        error: null,
        initialized: false,
        config: null,
        loading: false,
        apiDef: null
};

const loadMetadataConfigStart = (state, action) => {
    return updateObject( state, { initialized: false } );
}

const loadMetadataConfigSuccess = (state, action) => {
	console.log(action.config);
    return updateObject( state, { initialized: true, config: { ...state.config, ...action.config }} );
}


const loadMetadataConfigFail = (state, action) => {
    return updateObject( state, {
        error: 'Could not load metadata config.',
        initialized: false
    });
}

const loadSoapApiDefSuccess = (state, action) => {
    const apiDef = {
        [Metadata.OBJECT_TYPE_CLIP]: [],
        [Metadata.OBJECT_TYPE_PROJECT]: []
    }
    
    if(action.apiDef && action.apiDef.metadata) {
        action.apiDef.metadata.forEach(item => {
            apiDef[Metadata.OBJECT_TYPE_CLIP].push(item.xmlname);
        });
    }
    
    if(action.apiDef && action.apiDef.metadata) {
        action.apiDef.projectmetadata.forEach(item => {
            apiDef[Metadata.OBJECT_TYPE_PROJECT].push(item.xmlname);
        });
    }
    
    return updateObject( state, { apiDef: apiDef } );
}

const updateMetadataConfig = (state, action) => {
    const config = {
        ...state.config,
        [action.field]: action.config
    }
    return updateObject( state, { config: config } );
}


const reducer = ( state = initialState, action) => {
    switch (action.type) {
        case actionTypes.LOAD_METADATA_CONFIG_START: 
            return loadMetadataConfigStart(state, action);
        case actionTypes.LOAD_METADATA_CONFIG_SUCCESS: 
            return loadMetadataConfigSuccess(state, action);
        case actionTypes.LOAD_METADATA_CONFIG_FAIL: 
            return loadMetadataConfigFail(state, action);
        case actionTypes.LOAD_SOAP_API_DEF_SUCCESS: 
            return loadSoapApiDefSuccess(state, action);
        case actionTypes.UPDATE_METADATA_CONFIG: 
            return updateMetadataConfig(state, action);
        case actionTypes.SAVE_METADATA_CONFIG_START:
            return updateObject(state, { loading: true });
         case actionTypes.SAVE_METADATA_CONFIG_SUCCESS:
            return updateObject(state, { loading: false });
        case actionTypes.SAVE_METADATA_CONFIG_FAIL:
            return updateObject(state, { loading: false });
        case actionTypes.METADATA_LOADING:
            return updateObject(state, { loading: action.loading });
        default: 
            return state;
    }
}

export default reducer;
